var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.047a2 2 0 00-2-2H7.474l-.548-1.67A2 2 0 005.026 0H2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V5.047z",
    fill: "#FFCA5A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8 0 0 .8 2 6)",
    fill: "#C88B0A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.289,
    cy: 2.025,
    r: 1.934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.762 8.142L6.763 5.6a1 1 0 011.571 0l.17.215a1 1 0 001.571 0l.17-.215a1 1 0 011.57 0l2.001 2.54a1 1 0 01-.785 1.62H5.548a1 1 0 01-.786-1.62z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.422,
    cy: 2.669,
    r: 1.289
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.276 6.83l.999-1.198a1 1 0 011.6.086l.177.264a1 1 0 010 1.11l-.623.934a1 1 0 01-.832.445h-.553a1 1 0 01-.768-1.64z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA1LjA0N2EyIDIgMCAwMC0yLTJINy40NzRsLS41NDgtMS42N0EyIDIgMCAwMDUuMDI2IDBIMmEyIDIgMCAwMC0yIDJ2MTJhMiAyIDAgMDAyIDJoMTJhMiAyIDAgMDAyLTJWNS4wNDd6IiBmaWxsPSIjRkZDQTVBIi8+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLjggMCAwIC44IDIgNikiIGZpbGw9IiNDODhCMEEiPjxjaXJjbGUgY3g9IjkuMjg5IiBjeT0iMi4wMjUiIHI9IjEuOTM0Ii8+PHBhdGggZD0iTTQuNzYyIDguMTQyTDYuNzYzIDUuNmExIDEgMCAwMTEuNTcxIDBsLjE3LjIxNWExIDEgMCAwMDEuNTcxIDBsLjE3LS4yMTVhMSAxIDAgMDExLjU3IDBsMi4wMDEgMi41NGExIDEgMCAwMS0uNzg1IDEuNjJINS41NDhhMSAxIDAgMDEtLjc4Ni0xLjYyeiIvPjxjaXJjbGUgY3g9IjUuNDIyIiBjeT0iMi42NjkiIHI9IjEuMjg5Ii8+PHBhdGggZD0iTTIuMjc2IDYuODNsLjk5OS0xLjE5OGExIDEgMCAwMTEuNi4wODZsLjE3Ny4yNjRhMSAxIDAgMDEwIDEuMTFsLS42MjMuOTM0YTEgMSAwIDAxLS44MzIuNDQ1aC0uNTUzYTEgMSAwIDAxLS43NjgtMS42NHoiLz48L2c+PC9zdmc+";
export { SvgFolderPeople as ReactComponent };